module.exports = __webpack_public_path__ + "static/media/Italian_traffic_signs_Altri_Pericoli-CL.8d47f12b.svg";